import './styles/section.popup.scss';
class PopupByURLComponent extends HTMLElement {
    popupName = this.dataset.name;
    closeBtn = this.querySelector('.popup-block__close');
    overlay = document.querySelector('.main-overlay');
    thanksMessage = document.querySelector('.temporary-popup-thanks');
    constructor() {
        super();
        this.close = this.close.bind(this);
        const url = window.location.search;
        if (!url.includes('?pop') && !url.includes('&pop'))
            return;
        let nameFromURL = url.includes('&pop')
            ? url.substring(url.lastIndexOf('&pop') + 5)
            : url.substring(url.lastIndexOf('?pop') + 5);
        if (nameFromURL.includes('&')) {
            nameFromURL = nameFromURL.substring(0, nameFromURL.indexOf('&'));
        }
        nameFromURL = nameFromURL.includes('/')
            ? nameFromURL.substring(0, nameFromURL.indexOf('/'))
            : nameFromURL;
        if (nameFromURL !== this.popupName)
            return;
        this.hidden = false;
        this.closeBtn?.addEventListener('click', this.close);
        if (this.overlay !== null) {
            this.overlay.setAttribute('aria-hidden', 'false');
            this.overlay.addEventListener('click', this.close);
        }
        const couponInput = this.querySelector('input');
        if (couponInput !== null) {
            this.querySelector('a')?.addEventListener('click', event => {
                event.preventDefault();
                couponInput.focus();
                couponInput.select();
                couponInput.setSelectionRange(0, 99999);
                document.execCommand('copy');
                this.close();
                if (this.thanksMessage !== null) {
                    this.thanksMessage.classList.add('show');
                    setTimeout(() => {
                        this.thanksMessage?.classList.remove('show');
                    }, 3000);
                }
            });
        }
    }
    close() {
        this.hidden = true;
        if (this.overlay !== null) {
            this.overlay.setAttribute('aria-hidden', 'true');
            this.overlay.removeEventListener('click', this.close);
        }
    }
}
customElements.define('popup-url-component', PopupByURLComponent);
class PopupTemporaryComponent extends HTMLElement {
    id = this.dataset.id ?? '';
    timeToShow = +(this.dataset.timeShow ?? 0);
    timeDifference = +(this.dataset.timeDifference ?? 0);
    timeStart = Date.parse((this.dataset.timeStart ?? ''));
    timeEnd = Date.parse((this.dataset.timeEnd ?? ''));
    timeNow = Date.now();
    showBeforeLeave = (this.dataset.beforeLeave ?? '') === 'true';
    closeBtn = this.querySelector('.popup-block__close');
    couponInput = this.querySelector('input');
    overlay = document.querySelector('.main-overlay');
    thanksMessage = document.querySelector('.temporary-popup-thanks');
    constructor() {
        super();
        if (this.timeToShow === 0 ||
            this.timeDifference === 0 ||
            isNaN(this.timeStart) ||
            isNaN(this.timeEnd) ||
            this.id === '') {
            return;
        }
        const timeZone = new Date().getTimezoneOffset() * 60000;
        const newDate = this.timeNow - timeZone + this.timeDifference;
        if (newDate <= this.timeStart || newDate >= this.timeEnd) {
            return;
        }
        this.closeBtn?.addEventListener('click', this.close);
        const timeStampFromStorage = sessionStorage.getItem(`timeFirstVisit--${this.id}`);
        let timeStamp;
        if (timeStampFromStorage === 'showed') {
            return;
        }
        else if (timeStampFromStorage === null) {
            timeStamp = this.timeNow;
            sessionStorage.setItem(`timeFirstVisit--${this.id}`, this.timeNow.toString());
        }
        else {
            timeStamp = +timeStampFromStorage;
        }
        const difference = Date.now() - timeStamp;
        if (this.showBeforeLeave && window.innerWidth > 1200) {
            document.addEventListener('mouseleave', this.show.bind(this));
        }
        else if (difference >= this.timeToShow) {
            this.show();
        }
        else {
            setTimeout(this.show.bind(this), this.timeToShow - difference);
        }
    }
    show() {
        this.hidden = false;
        if (this.overlay !== null) {
            this.overlay.setAttribute('aria-hidden', 'false');
            this.overlay.addEventListener('click', this.close.bind(this));
        }
        sessionStorage.setItem(`timeFirstVisit--${this.id}`, 'showed');
    }
    close() {
        this.hidden = true;
        if (this.overlay !== null) {
            this.overlay.setAttribute('aria-hidden', 'true');
            this.overlay.removeEventListener('click', this.close);
        }
    }
}
customElements.define('popup-temporary-component', PopupTemporaryComponent);
